import React, { useState, useEffect, useContext } from 'react'
import { useJwt } from 'react-jwt'
import UserContext from '../contexts/UserContext'
import { UserProviderProps } from '../types/globalTypes'
import { validateTokenAndRedirect } from '../utils/tokenValidation'

const PrivateRoute: React.FC<UserProviderProps> = (props) => {
  const { token, setToken, setUser } = useContext(UserContext)
  const { isExpired, decodedToken } = useJwt(token)
  const [statusValidate, setStatusValidate] = useState<boolean>(false)

  useEffect(() => {
    validateAccess()
  }, [token, isExpired])

  const validateAccess = () => {
    const isValid = validateTokenAndRedirect(token)
    
    if (!isValid) {
      // Limpa o contexto do usuário quando token é inválido
      setToken('')
      setUser({} as any)
      return
    }
    
    setStatusValidate(true)
  }

  return <>{statusValidate ? props.children : <></>}</>
}

export default PrivateRoute
